/**
 * Statistics API Service
 */

import { apiClient } from './client'
import type { FunnelStats, FunnelFilterParams } from '@/types/api'

/**
 * Get funnel statistics and conversion metrics
 */
export async function getFunnelStats(params?: FunnelFilterParams): Promise<FunnelStats> {
  return apiClient.get<FunnelStats>('/stats/funnel', { params })
}

export const statsService = {
  getFunnelStats,
}
